import { render, staticRenderFns } from "./rtfPreviewDetail.vue?vue&type=template&id=40b65120&scoped=true"
import script from "./rtfPreviewDetail.vue?vue&type=script&lang=js"
export * from "./rtfPreviewDetail.vue?vue&type=script&lang=js"
import style0 from "./rtfPreviewDetail.vue?vue&type=style&index=0&id=40b65120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b65120",
  null
  
)

export default component.exports